import '../sass/index.scss';
import Map from './Classes/Map';

const map = new Map({
  mapId: 'alernanceMap',
  style: 'mapbox://styles/robinverheyden/cl3if7afc000214nzwrx7t7ty',
  center: [4.318554, 50.84372],
  zoom: 9,
  iconSize: 50,
  locations: [
    {
      pos: [4.2389981, 50.5740642],
    },
    {
      pos: [3.2333, 50.7333],
    },
    {
      pos: [4.8661892, 50.4665284],
    },
    {
      pos: [4.859377384185791, 50.471309661865234],
    },
  ],
});

map.init();
